import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';

import {Router} from '@angular/router';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CartData, Results, User, WishList} from '../../../classes/app.models';
import {AuthenticationService} from '../../../services/authentication.service';
import {ApiService} from '../../../services/api.service';
import {ToastrService} from 'ngx-toastr';
import {WishlistService} from '../../../services/wishlist.service';

@Component({
    selector: 'indiapicture-wishlist-dialog',
    templateUrl: './wishlist-dialog.component.html',
    styleUrls: ['./wishlist-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class WishlistDialogComponent implements OnInit {
    @Output() onClose = new EventEmitter<any>(true);
    wishlistForm: FormGroup;
    currentUser: User;
    wishList: WishList[];
    wishProduct: CartData;
    // private _wishlist_id: number = 0;
    hideAddGallery: boolean = true;
    @Input() product: Results;

    // public get wishlist_id() {
    //     return this._wishlist_id;
    // }
    //
    // public set wishlist_id(_wishlist_id) {
    //     this._wishlist_id = _wishlist_id;
    // }

    constructor(public formBuilder: FormBuilder, public router: Router, public authservice: AuthenticationService,
                private apiService: ApiService, private toastrService: ToastrService, private wishlistService: WishlistService) {
        this.authservice.currentUser.subscribe(x => this.currentUser = x);
    }

    ngOnInit() {
        this.wishProduct = Object.assign({
            id: this.product.id,
            filename: this.product.filename,
            thumbnail: this.product.thumbnail,
            preview: this.product.preview,
            license: this.product.license,
            collection: this.product.collection,
            type: this.product.preview.endsWith('.mp4') ? 'Video' : 'Image',
            caption: this.product.caption,
            category: this.product.category,
            time: this.product.time,
            author: this.product.author
        });
        this.wishlistForm = this.formBuilder.group({
            title: ['', Validators.compose([Validators.required, Validators.maxLength(30)])]
        });
        this.getWishList();
    }

    public onSubmit(values: any): void {
        if (this.wishlistForm.valid) {
         //  console.log(this.wishProduct);
            this.wishlistService.addToWishList(this.wishProduct, values.title);
            this.closeModal();
            // this.apiService.addToWishListDB(JSON.stringify(this.wishProduct), values.title, this.currentUser.customers_id).subscribe(data => {
            //     if (data.statusCode == 200) {
            //         this.toastrService.success('Your New Creation Is Completed. Please go ahead to share the same with your colleagues!');
            //         this.closeModal();
            //     } else {
            //         this.toastrService.error('Image not added there is some issue');
            //     }
            // });
        }

    }

    /** The name put in the box when the customer has no gallery yet. */
    static readonly FIRST_GALLERY_NAME = 'default';

    public getWishList() {
        this.apiService.getWishList(this.currentUser.customers_id).subscribe(data => {
            this.wishList = data['data'] || [];

            /*
             * No gallery yet, so the create form opens with a name already in it.
             *
             * Otherwise the modal offers a "Select Gallery" dropdown with nothing
             * in it and a Create New button, and the only way forward is to work
             * out that the button has to be pressed and then think of a name —
             * two steps before the image can be saved at all.
             *
             * patchValue leaves the control pristine but DOES make the form
             * valid, which is what takes the Add button out of its disabled
             * state. The name is still editable; it is a default, not a fixed
             * value.
             */
            if (!this.wishList.length) {
                this.hideAddGallery = false;
                this.wishlistForm.patchValue({
                    title: WishlistDialogComponent.FIRST_GALLERY_NAME
                });
            }
        });
    }

    public addToWishList(selectedWishList: WishList) {

        if (selectedWishList.imagesArray.filter(arr => arr.id == (this.wishProduct.id + '')).length > 0) {
            this.toastrService.success(this.wishProduct.type + ' already exist');
        } else {
            this.wishlistService.updateToWishList(this.wishProduct, selectedWishList.id);
            this.closeModal();
            // this.apiService.updateToWishListDB(JSON.stringify(this.wishProduct), selectedWishList.id, false).subscribe(data => {
            //     if (data.statusCode == 200) {
            //         this.toastrService.open(this.wishProduct.type + ' added to list');
            //         this.closeModal();
            //     } else {
            //         this.toastrService.error(this.wishProduct.type + ' not added there is some issue');
            //     }
            // });
        }


    }

    public closeModal(): void {
        let modal = document.querySelector('.login-modal') as HTMLElement;
        if (modal) {
            modal.click();
        }
    }

    onWishlist($event: Event) {
        const selectedWishList = this.wishList.filter(item => item.id == $event.target['value'])[0];
        this.addToWishList(selectedWishList);

    }

    public showAddForm() {
        this.hideAddGallery = false;

    }
}
